// components/ServiceCard.tsx
import React, { useEffect } from "react";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import { ServiceData } from "../../types/service";
import { useNavigate } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle } from "../../components/ui/card";
import { Button } from "../../components/ui/button";

type Props = {
  service: ServiceData;
  setSelectedVisa?: (service: ServiceData) => void;
};

const ServiceCard = ({ service, setSelectedVisa }: Props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  // --- derive dynamic data for the card ---
  const fee = (Number(service?.price) || 0) + (Number(service?.centerFee) || 0);

  const processingText =
    (service as any)?.processingTime ||
    (service as any)?.processing_time ||
    "3 Working Days";

  const validityVal =
    (service as any)?.validity ||
    (service as any)?.validityDays ||
    30;
  const validityText =
    typeof validityVal === "number" ? `${validityVal} days` : String(validityVal);

const handleApplyNow = (title: string) => {
  if (setSelectedVisa) setSelectedVisa(service);

  const element = document.getElementById("sideForm");
  if (element) {
    element.scrollIntoView({ behavior: "smooth", block: "start" });

    // Wait for scroll animation to finish before focusing
    setTimeout(() => {
      const input = document.getElementById("customerNameInput") as HTMLInputElement;
      const inputKsa = document.getElementById("customerNameInput1") as HTMLInputElement;
      input?.focus();
      inputKsa?.focus();
    }, 600); // Adjust delay if needed
  }

  // navigate(`/listings/service-details/${service.id}`);
};

  return (
    <div className="w-full md:w-full mb-2 px-2">
      <Card className="bg-gray-50/70 border-gray-200 shadow-sm rounded-xl overflow-hidden flex flex-col h-full">
        <CardHeader className="bg-gray-100 p-4">
          <CardTitle className="text-base font-bold text-neutral-700">
            {service.name}
          </CardTitle>
        </CardHeader>

        <CardContent className="p-4 flex-grow flex flex-col">
          <div className="space-y-3">
            <div className="flex justify-between items-center text-sm">
              <p className="text-muted-foreground">Processing time:</p>
              <p className="font-semibold">{processingText}</p>
            </div>

            <div className="flex justify-between items-center text-sm">
              <p className="text-muted-foreground">Validity:</p>
              <p className="font-semibold">{validityText}</p>
            </div>

            <div className="flex justify-between items-center text-lg">
              <p className="text-muted-foreground">Fees:</p>
              <p className="font-bold text-primary">{t("AED")} {fee.toLocaleString()}</p>
            </div>
          </div>

          <div className="mt-auto pt-3 text-center">
            <Button
              onClick={() => handleApplyNow(service.name)}
              className="bg-primary hover:bg-primary/90"
              size="sm"
            >
              {t("Apply Now")}
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default observer(ServiceCard);
